import React, { useState, Component } from 'react';
import Heading from './Heading.js';



class TextBox extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      isHovered: false
    };

    // This binding is necessary to make `this` work in the callback
    this.handleHover = this.handleHover.bind(this);
  }

  handleHover = () => this.setState({ isHovered: !this.state.isHovered });
  

  render() {
    const { width, height, cx, headingLevel, firstLevel, secondLevel, thirdLevel, firstContent, secondContent, thirdContent, br, border, hover, bg, bgColor } = this.props;
    const FirstText = firstLevel;
    const SecondText = secondLevel;
    const ThirdText = thirdLevel;
    // <Title className={`w-${width} h-${height} ${cx}`}>{content}</Title>



    return (
      <div className={`text-box flex wrap w-${width} db ${cx} `}>
          <div className={`flex wrap ${border} br-${br} pa-s pl-m hover-animation ${bgColor} ${this.state.isHovered ? {hover} : ""}  `}  onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
            <FirstText className="flex-basis-100 truncate letter-spacing-small">{firstContent}</FirstText>
            <SecondText className="flex-basis-100 truncate letter-spacing-small">{secondContent}</SecondText>
            <ThirdText className="flex-basis-100 truncate letter-spacing-small">{thirdContent}</ThirdText>
          </div>
      </div>
    
    );
  }
}


export default TextBox;